import { createUserManager } from 'redux-oidc';

import config from 'config/site.config';

const { oidc } = config;

const baseUrl = `${window.location.protocol}//${window.location.hostname}${
  window.location.port ? `:${window.location.port}` : ''
}`;

const userManagerConfig = {
  authority: oidc.authority,
  client_id: 'ditio_web_client',
  response_type: 'code',
  scope:
    'openid masstransportapiv1 reportingapiv1 ditioapiv3 profile offline_access',
  redirect_uri: `${baseUrl}/callback`,
  post_logout_redirect_uri: `${baseUrl}/logged-out`,
  automaticSilentRenew: true,
  monitorSession: false,
  accessTokenExpiringNotificationTime: 300,
};

let instance = null;

export const getUserManager = () => {
  if (instance) return instance;

  instance = createUserManager(userManagerConfig);
  return instance;
};
